import modalTemplate from './view.html';

import { MailServerModalController } from './controller';

import { MAIL_SERVER_MODAL_CONTROLLER } from '../../const';

class MailServerModal {
    constructor($uibModal) {
        'ngInject';
        this.$uibModal = $uibModal;
        this.modalInstance = null;
    }

    open = (serverId) => {
        this.modalInstance = this.$uibModal.open({
            template: modalTemplate,
            bindToController: true,
            controller: MAIL_SERVER_MODAL_CONTROLLER,
            controllerAs: '$',
            size: 'md',
            resolve: {
                serverId: serverId,
            },
            backdrop: 'static',
            keyboard: false,
        });

        return this.modalInstance.result;
    };
}

export {
    MailServerModalController,
    MailServerModal,
};
